<button (click)="setBackValue()">{{ backLabel }}</button>
<button (click)="setForwardValue()">{{ forwardLabel }}</button>
<span>{{ currentLabel }}</span>
<input type="hidden" [formControl]="control" />
